import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import ToTop from './ToTop';
import bowser from 'bowser';
import inview from 'jquery-inview';
import FloatAnimation from './FloatAnimation';
import slick from 'slick-carousel';
import {TweenMax, TimelineMax} from "gsap";
import Swiper from 'swiper';

if (bowser.msie === true) {
	let version = 'ie_' + Math.floor(bowser.version);
	$('body').addClass('ie ' + version);
} else if (bowser.msedge === true) {
	$('body').addClass('edge');
} else if (bowser.firefox === true) {
	$('body').addClass('ff');
} else if (bowser.tablet === true) {
	$('body').addClass('tablet');
}

if (bowser.mobile === true) {
	$('body').addClass('device--mobile');
	if (bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
} else {
	os = '';
}

if( ua.indexOf('Android') > 0 ) {
	$('body').addClass('device--mobile--android');
}

$('body').addClass(os);
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();

/* ===============================================
#	const
=============================================== */
const _w = $(window);

/* ===============================================
#	float nav fade in/out
=============================================== */
_w.on("load scroll",function(){
	let currentY = _w.scrollTop();
	const floatNav = $(".c-floatNav");
	const wovn = $('#wovn-translate-widget');
 	if(currentY > 200){
		floatNav.addClass("-is-active");
		wovn.addClass('-is-display');

	}else{
		floatNav.removeClass("-is-active");
		wovn.removeClass('-is-display');
	}
});

/* ===============================================
#	inview
=============================================== */


// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
// $(window).on('load', function () {
$(function(){
	let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});


// アニメーション部分の画像をランダム

function mv_random(){
	var ua = navigator.userAgent;
	const url = window.location.href;
	let selectvalue = [];


	function random(_this){
		let randRange = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
		let randvalue = randRange(1, 4);

		let val = $.inArray(randvalue, selectvalue);

		if(val != -1) {
			random(_this);
		}else{
			if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
				const result = 'url("./build/images/top_mv/sp/tbsp_0' + randvalue + '.jpg")';
				$(_this).css("background-image",result);
				selectvalue.push(randvalue);
			} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
				const result = 'url("./build/images/top_mv/sp/tbsp_0' + randvalue + '.jpg")';
				$(_this).css("background-image",result);
				selectvalue.push(randvalue);
			} else {
				const result = 'url("./build/images/top_mv/pc_0' + randvalue + '.jpg")';
				$(_this).css("background-image",result);
				selectvalue.push(randvalue);
			}
		}
	}


	$('.p-hero_slide-item').each(function(){
		let _this = $(this);
		random(_this);
	});

}
/* ===============================================
#	navigagion
=============================================== */
const spnavi = $("#spnavi");

$('.p-thumblist-item-img').on('click',function(){
	naviClose();
});

let offset_retea = 0;

//閉じる
const naviClose = ()=>{
	$("#spnavi").removeClass("-scroll");
	$("#spnavi").removeClass("-active");
	$(".p-naviarea").removeClass("-show");
	$(".btn_sp_navi").removeClass("-active");
	//$('.js-globalHeader').css('display','block');
	$('.js-spnaviBtn').css('display','block');
	$('.js-globalHeader').addClass('-is-active');
	$('.p-naviarea-left-close').removeClass('_active');
	$("body").removeClass("-fixed");
	headerGlobal_Position_reset();
	$(window).scrollTop(offset_retea);
}

//開く
const naviOpen = ()=>{
	offset_retea = $(window).scrollTop();
	$("#spnavi").addClass("-active");
	$(".p-naviarea").addClass("-show");
	$(".btn_sp_navi").addClass("-active");
	$(".btn_sp_navi_wrap").addClass("-show-width-nav");
	$('.p-naviarea-left-close').addClass('_active');
	$('.js-spnaviBtn').css('display','none');
	$('.js-globalHeader').removeClass('-is-active');
	$("body").addClass("-fixed");
	$("#spnavi").addClass("-scroll");
	headerGlobal_Position();
}


const headerGlobal_Position = ()=> {
	let ww = $(window).width();
	let wst = $(window).scrollTop();
	let target_position = $('.js-globalHeader').offset().top;
	$('.js-globalHeader').css('top', wst + target_position);
	$('#spnavi').on('scroll',function(){
		if($("#spnavi").hasClass("-active")) {
			let ww = $(window).width();
			if(ww < 769) {
				let naviscroll = $('#spnavi').scrollTop();
				$('.js-globalHeader').css('top', wst + target_position - naviscroll);
			}
		}
	});
}

const headerGlobal_Position_reset = ()=> {
	let wst = $(window).scrollTop();
	$('.js-globalHeader').css('top', '');
}



//ナビゲーションカテゴリ切り替え
const switchNaviCategory = (elem)=>{
	let cat = $(elem).data("cat");
	// console.log(cat);
	$(".c-thumbnail-hastext").fadeOut(500);
	if(cat === "cat_all"){
		$.when(
			$(".c-thumbnail-hastext").fadeOut(100)
		)
		.done(function(){
			$(".c-thumbnail-hastext").fadeIn(500)
		});
	}else{
		$.when(
			$(".c-thumbnail-hastext").fadeOut(100)
		)
		.done(function(){
			$(`.c-thumbnail-hastext[data-cat=${cat}]`).fadeIn(500)
		});
	}
}

const initNavi =(elem)=>{
	let cat = $(elem).data("cat");
	$(".c-thumbnail-hastext").hide();
	if(cat === "cat_all"){
		$(`.c-thumbnail-hastext`).show();
	}else{
		$(`.c-thumbnail-hastext[data-cat=${cat}]`).show();
	}
}

const switchnaviCurrent = (elem)=>{
	$(".js-spnavi p").removeClass("-is-current");
	$(elem).addClass("-is-current");
}

//PC navi
$(".js-spnavi p").on("click",function(){
	let _this = this;
	switchnaviCurrent(_this);
	if(spnavi.hasClass("-active")){
		switchNaviCategory(_this);
	}else{
		initNavi(_this);
		naviOpen();
	}
});

$(".p-naviarea-left-close").on("click",function(e){
	if(spnavi.hasClass("-active")){
		naviClose();
		$(".js-spnavi p").removeClass("-is-current");
	}
});

$(".p-naviarea").on("click",function(e){
	if(spnavi.hasClass("-active")){
		naviClose();
		$(".js-spnavi p").removeClass("-is-current");
	}else{
		naviOpen();
	}
});

//TAB & SP navi
$(".js-spnaviBtn").on("click",function(){
	if(spnavi.hasClass("-active")){
		naviClose();
	}else{
		naviOpen();

	}
});

//ページ内リンクの時の処理
$(".c-thumbnail-hastext").on("click",function(e){
	// console.log('click');
	e.stopPropagation()
	naviClose();
});

/* ===============================================
#	navigagion btn fade in/out
=============================================== */
_w.on("load resize scroll", function () {
	const target = $(".btn_sp_navi_wrap");
	let scrollTop = $(this).scrollTop();
	let firstVewH = $(".js-navi-btn-threshold").height();
	if (scrollTop >= firstVewH) {
		target.addClass("-visible");
		target.addClass("-show");
	} else {
		target.removeClass("-show");
		target.removeClass("-visible");
	}
})


/*
_w.on('load resize scroll',function(){
	let target = $(".btn_sp_navi_wrap._bottom");
	let target_position = target.offset().top;
	let scrollTop = $(this).scrollTop();
	let scroll_height = $(this).height();
	let scroll_bottom_position = scrollTop + scroll_height;
	let document_height = $(document).height();
	let ft_position = $("#global_footer").offset().top;
	let bottom_val = document_height - ft_position;
	if(scroll_bottom_position >= ft_position) {
		target.addClass('_fixa');
		target.css('bottom',bottom_val + 2);
	}else{
		target.removeClass('_fixa');
		target.css('bottom','0');
	}
})
*/

// wovnも同じ（言語バー）
/*
_w.on('load resize scroll',function(){
	let target = $("#wovn-translate-widget");
	let target_position = target.offset().top;
	let scrollTop = $(this).scrollTop();
	let scroll_height = $(this).height();
	let scroll_bottom_position = scrollTop + scroll_height;
	let document_height = $(document).height();
	let ft_position = $("#global_footer").offset().top;
	let bottom_val = document_height - ft_position;
	if(scroll_bottom_position >= ft_position) {
		target.addClass('_fixa');
		target.css('bottom',bottom_val + 2);
	}else{
		target.removeClass('_fixa');
		target.css('bottom','0');
	}
})
*/

/* ===============================================
#	lazyload
=============================================== */
/*$(function($){
  $("img.js-lazyload").lazyload({
	// threshold: 400,    // 読み込み閾値 px
	// effect: 'fadeIn',  // 読み込みエフェクト
	failure_limit: 50,
  });
});*/

if($('body').hasClass('category')) {
	$(window).on('load',function(){
		$(".js-inview-element").on("inview",function(){
			$(this).addClass("-show");
		});
	});
} else {
	$(function(){
		$(".js-inview-element").on("inview",function(){
			$(this).addClass("-show");
		});
	});
}

$(".js-inview-element-mv").on("inview",function(){
	$(this).addClass("-show");
});
/* ===============================================
#	p-splash animation
=============================================== */



// $(".js-hero").one("inview",function(){
// 	// TweenMax.delayedCall(0.8, splashAnimation);
// 	splashAnimation();
// });

/* ===============================================
#	hero text animation
=============================================== */
//text animation
const showTextAnim = (targetObj) => {
	const target = $(targetObj);
	const targetsP = target.find("p");
	if(!target.hasClass("-is-animated")){
		targetsP.each(function (index) {
			let _this = $(this);
			let textArr = _this.text().split('');
			for (let i = 0; i < textArr.length; i++) {
				textArr[i] = "<span style='opacity:0;'>" + textArr[i] + "</span>";
			}
			_this.html(textArr.join(""));

			let targets = _this.find("span");
			target.addClass("-is-show");
			TweenMax.delayedCall(0.1 * index, function () {
				TweenMax.staggerTo(targets, 1, {css: {opacity: 1}}, 0.03);
			});
		});
		target.addClass("-is-animated");
	}
};
$(".js-textAnim").on("inview",function(){
	showTextAnim(".js-textAnim");
});


/*
const p_hero_slide = new Swiper ('.p-hero_slide', {
	loop: true,
	speed:1000,
	autoplay:4000,
	effect:"fade",
	clickable:true,
	slideToClickedSlide: true,
	slidesPerView:1
});
*/


$(function(){

	mv_random();

	$(".p-hero_slide").slick({
		slidesToShow: 1,
		infinite: true,
		autoplay: true,
		speed: 1000,
		autoplaySpeed: 2500,
		fade: true,
		pauseOnHover: false
	});

	$('.p-hero_slide-item').eq(0).addClass('-is-animate');
	$('.p-hero_slide-item.-is-animate').on('webkitAnimationEnd', function(){
		setTimeout(function(){
			$('.js-globalHeader').addClass('-animate');
			$('.js-globalHeader').addClass('-is-active');
			$('.p-heroCategory_arrow._top').addClass('_active');
		}, 500);
	});
	/*$('.p-hero_slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		let next_slide = $("[data-slick-index='" +nextSlide+ "']");
		$(next_slide).find('.p-hero_slide-item').addClass('-is-animate');
		setTimeout(function(){
			let current_slide = $("[data-slick-index='" +currentSlide+ "']");
			$(current_slide).find('.p-hero_slide-item').removeClass('-is-animate');
		},1000)
	});*/
});


$(function(){
	let i = 0;
	let mySwiper = [];
	$('.p-product-item-img').each(function() {

		mySwiper['target' + i] = new Swiper ($(this), {
			loop: true,
			speed: 600,
			autoplay:200,
			slidesPerView: 1,
			effect : 'fade',
			autoplay : 3000,
			speed: 1000,
			spaceBetween: 0
		});
		i++;
	});
});


/* ===============================================
#	下層ページ
=============================================== */
/* ===============================================
#	lower sub images
=============================================== */

/*$(".js-random-fadein").on("inview",function(){
	let tl3 = new TimelineMax();
	let elem = $(this).find(".js-random-fadein-item").get();
	//配列をシャッフル
	for(let i = elem.length-1;i>0;i--){
		let j = Math.floor(Math.random()*(i+1));
		let tmp = elem[i];
		elem[i] = elem[j];
		elem[j] = tmp;
	}
	tl3.staggerTo(elem,0,{css:{className:'+=is-show'}},0.2);
})*/

$(document).ready(function() {
	setpulldown();
});

/* ===============================================
#	売り消し機能
=============================================== */
$(".p-product-item-thumb-col").each(function(){
	$(this).addClass($(this).data("pd"));
})

const belowMv = () => {
	const wct = $(window).scrollTop();
	const mvHeight = $('.p-hero').height();
	if (wct > mvHeight) {
		return true
	} else {
		return false
	}
};

$(function () {
	if(belowMv()) {
		if ($('.c-floatNav').hasClass('-is-hide')) {
			$('.c-floatNav').removeClass('-is-hide');
			$('#wovn-translate-widget').addClass('-is-hide');
		}
	} else {
		if (!$('.c-floatNav').hasClass('-is-hide')) {
			$('.c-floatNav').addClass('-is-hide');
			$('#wovn-translate-widget').removeClass('-is-hide');
		}
	}
	$(window).on('scroll', function () {
		let footerPos = $('.l-global_footer-navStop').offset().top;
		let footerHeight = $('.l-global_footer-navStop').height();
		let wb = $(window).scrollTop() + $(window).height();
		if(belowMv()) {
			if ($('.c-floatNav').hasClass('-is-hide')) {
				$('.c-floatNav').removeClass('-is-hide');
				$('#wovn-translate-widget').addClass('-is-hide');
			}
		} else {
			if (!$('.c-floatNav').hasClass('-is-hide')) {
				$('.c-floatNav').addClass('-is-hide');
				$('#wovn-translate-widget').removeClass('-is-hide');
			}
		}
		if (wb >= footerPos) {
			$('.c-floatNav').css({
				'position': 'absolute',
				'bottom': footerHeight
			});
			$('#wovn-translate-widget').css({
				'cssText': 'position: absolute; bottom: ' + footerHeight + 'px!important;'
			});
		} else {
			$('.c-floatNav').css({
				'position': 'fixed',
				'bottom': 0
			});
			$('#wovn-translate-widget').css({
				'cssText': 'position: fixed; bottom: ' + 0 + '!important;'
			});
		}
	})
})
